import { create } from "zustand";
import { persist } from "zustand/middleware";

interface InventoryPreference {
  inventories: string[];
  facilities: string[];
  channels: string[];
  setInventories: (inventories: string[]) => void;
  setFacilities: (facilities: string[]) => void;
  setChannels: (channels: string[]) => void;
  reset: () => void;
}

export const useInventoryPreferenceStore = (orgId: string) => {
  const store = create<InventoryPreference>()(
    persist(
      (set) => ({
        inventories: [],
        facilities: [],
        channels: [],
        setInventories: (inventories) => set((state) => ({ ...state, inventories })),
        setFacilities: (facilities) => set((state) => ({ ...state, facilities })),
        setChannels: (channels) => set((state) => ({ ...state, channels })),
        reset: () => set((state) => ({ ...state, inventories: [], facilities: [], channels: [] })),
      }),
      {
        name: `inventory-preference-v2-${orgId}`,
      }
    )
  );

  return store;
};
